import { render, staticRenderFns } from "./broadcast-device.vue?vue&type=template&id=fb612e4a&"
import script from "./broadcast-device.vue?vue&type=script&lang=js&"
export * from "./broadcast-device.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports